<template lang="pug">
y-chip(:label="getStatus" :color="getStatusColor")
</template>

<script>
export default {
  props: {
    status: {
      type: String,
      default: 'draft'
    },
  },
  computed: {
    getStatus () {
      const status = this.status.split('_').join(' ')
      return status.charAt(0).toUpperCase() + status.slice(1)
    },
    getStatusColor () {
      switch (this.status) {
        case 'draft':
          return 'normal'
        case 'created':
          return 'green'
        case 'requested':
          return 'orange'
        case 'pending_approval':
          return 'orange'
        case 'approved':
          return 'green'
        case 'active':
          return 'green'
        case 'rejected':
          return 'red'
        case 'completed':
          return 'blue'
        case 'archived':
          return 'red'
        case 'deleted':
          return 'red'
        default:
          return 'grey'
      }
    }
  },

}
</script>

<style scoped>
</style>